{
    "Profile_Dwellings_Animal.animal": "FR: Animal",
    "Profile_Dwellings_Animal.animalDetails": "FR: Animal Details",
    "Profile_Dwellings_Animal.number": "FR: Number",
    "Profile_Dwellings_Animal.type": "FR: Type",
    "Profile_Dwellings_Animal.breed": "FR: Breed",
    "Profile_Dwellings_Animal.biteHistory": "FR: Bite History"
}
